import React from 'react';
import './loader.scss';
export class Loader extends React.PureComponent {
    render() {
        const { isShow, transparent, smallLoader, miniLoader, className, spinnerStyles, centeredLoader, isStretched, } = this.props;
        let IE = false;
        if (typeof navigator !== 'undefined') {
            if (navigator.appName === 'Microsoft Internet Explorer' ||
                !!(navigator.userAgent.match(/Trident/) ||
                    navigator.userAgent.match(/rv:11/))) {
                IE = true;
            }
        }
        return (React.createElement("div", { className: `loader ${className} ${isShow ? '_show' : ''} ${transparent ? '_transparent' : ''} ${isStretched ? '_stretched' : ''}` },
            isShow && (React.createElement("div", { style: spinnerStyles, className: `loader__spinner ${smallLoader ? '_small' : ''} ${centeredLoader ? '_centered' : ''} ${miniLoader ? '_mini' : ''}` },
                React.createElement("img", { className: `loader__img ${IE ? 'loader__rotate' : ''}`, src: "/assets/loader.svg", alt: "loader" }))),
            this.props.children));
    }
}
Loader.defaultProps = {
    isShow: false,
    isStretched: false,
    transparent: false,
    smallLoader: false,
    centeredLoader: false,
    className: '',
    spinnerStyles: {},
};
